import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Stacked from '../../shared/Stacked/stacked.vue';
import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
        Stacked
    }
})
export default class EpicHomeVideo extends Vue {
    public title: string = 'EpicHomeVideo';

    public configs = new CommonConfig();

    @Prop({ default: null })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
